import SSOForWebGame from './SSOForWebGame.class'

export { SSOForWebGame }
